angular
  .module('fca-used')
  .component('vehiclePreview', {
    bindings: {
      data: '<'
    },
    templateUrl: 'app/vehicle/vehicle-preview.html',
    controller: vehiclePreviewController,
    controllerAs: 'vehicle'
  });

vehiclePreviewController.$inject = ['$translate', '$state', '$timeout', '$element', '$localStorage', 'wishlist', 'CONFIG'];

function vehiclePreviewController($translate, $state, $timeout, $element, $localStorage, wishlist, CONFIG) {
  var self = this;
  self.config = CONFIG;

  self.toggleWishlist = function () {
    if (self.data.inWishlist) {
      self.removingFromWishlist = true;
      $timeout(function () {
        wishlist.remove(self.data.vehicleCode);
        self.data.inWishlist = false;
        self.removingFromWishlist = false;
      }, 400);
    } else {
      wishlist.add(self.data);
      self.data.inWishlist = true;
    }
  };

  self.openDetails = function () {
    $localStorage.lastSelectedVehicleCode = self.data.vehicleCode;
    $state.go('root.details', {
      vehicleCode: self.data.vehicleCode,
      sincom: self.data.dealer.SINCOM,
      brand: self.data.dealer.BRAND,
      siteCode: self.data.dealer.SITECODE
    });
  };
  self.$onInit = function () {
    self.data.inWishlist = Boolean(wishlist.get(self.data.vehicleCode));
    self.kw = Math.round(self.data.horsePower * 0.73549875);
    self.warranty = self.config.search.premium.warrantyCode;
    self.price = {
      price: self.data.priceCurrent,
      unit: CONFIG.search.price.unit
    };

    self.registration = {
      date: new Date(self.data.registrationYear, self.data.registrationMonth - 1, self.data.registrationDay),
      format: $translate.instant('vehicle_date_format')
    };

    $timeout(function () {
      if ($localStorage.lastSelectedVehicleCode === self.data.vehicleCode) {
        delete $localStorage.lastSelectedVehicleCode;
        $element[0].scrollIntoView({
          behavior: 'smooth'
        });
      }
    }, 100);
  };
}
